module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup",
    class: {
      'is-opened': _vm.isPopupOpened
    }
  }, [_c('transition-wrapper', {
    on: {
      "transition-start": _vm.onAnimationStart,
      "transition-end": _vm.onAnimationEnd
    }
  }, [(_vm.isMenuOpened) ? _c('the-menu') : _vm._e()], 1), _c('transition-wrapper', {
    on: {
      "transition-start": _vm.onAnimationStart,
      "transition-end": _vm.onAnimationEnd
    }
  }, [(_vm.isFormOpened) ? _c('feedback-form') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca9c835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/the-popup.vue
// module id = 491
// module chunks = 0